<template>
    <div>
        <fax-submission-modal :claim-id="claimId"></fax-submission-modal>
        <email-submission-modal :claim-id="claimId"></email-submission-modal>
        <submission-history-modal :client-id="clientId" :email-enabled="emailEnabled"></submission-history-modal>
        <add-attachments-modal :claimId="claimId"></add-attachments-modal>
        <browse-attachments-modal :claimId="claimId"></browse-attachments-modal>
        <forward-document-modal :contacts="contacts"></forward-document-modal>
        <delete-confirmation name="document" @confirm="deleteDocument"></delete-confirmation>
        <form-1009-modal :claim-id="claimId"></form-1009-modal>
        <document-disassociate-confirmation></document-disassociate-confirmation>      
        <authorization-document-list :claim-id="claimId" :email-enabled="emailEnabled"></authorization-document-list>
        <response-document-list :claim-id="claimId" :email-enabled="emailEnabled"></response-document-list>        
        <dispute-document-list :claim-id="claimId" :email-enabled="emailEnabled"></dispute-document-list>
        <service-document-list :claim-id="claimId" :document-id="documentId" :is-admin="isAdmin" :email-enabled="emailEnabled"></service-document-list>
        <other-document-list :claim-id="claimId"></other-document-list>
        <mailing-upload-modal></mailing-upload-modal>
        <document-tags></document-tags>
        <document-notes-modal></document-notes-modal>
    </div>
</template>

<script>
import FaxSubmissionModal from '../transmissions/FaxSubmissionComponent.vue';
import EmailSubmissionModal from '../transmissions/EmailSubmissionComponent.vue';
import SubmissionHistoryModal from '../transmissions/SubmissionHistoryComponent.vue';
import AddAttachmentsModal from '../transmissions/AddAttachmentsComponent.vue';
import BrowseAttachmentsModal from '../transmissions/BrowseAttachmentsComponent.vue';
import ForwardDocumentModal from '../documents/ForwardDocumentComponent.vue';
import Form1009Modal from '../form1009/Form1009Component.vue';
import DocumentDisassociateConfirmation from '../documents/DocumentDisassociateComponent.vue';
import ResponseDocumentList from '../documents/ResponseDocumentsComponent.vue';
import AuthorizationDocumentList from '../documents/AuthorizationDocumentsComponent.vue';
import DisputeDocumentList from '../documents/DisputeDocumentsComponent.vue';
import ServiceDocumentList from '../documents/ServiceDocumentsComponent.vue';
import OtherDocumentList from '../documents/OtherDocumentsComponent.vue';
import MailingUploadModal from '../MailingUploadComponent.vue';
import DocumentTags from '../documents/DocumentTagsComponent.vue';
import DocumentNotesModal from '../documents/DocumentNotesModalComponent.vue';

export default {
    components: {
        FaxSubmissionModal,
        EmailSubmissionModal,
        SubmissionHistoryModal,
        AddAttachmentsModal,
        BrowseAttachmentsModal,
        ForwardDocumentModal,
        Form1009Modal,
        DocumentDisassociateConfirmation,
        ResponseDocumentList,
        AuthorizationDocumentList,
        DisputeDocumentList,
        ServiceDocumentList,
        OtherDocumentList,
        MailingUploadModal,
        DocumentTags,
        DocumentNotesModal
    },
    props: {
        clientId: Number,
        claimId: Number,
        contacts: Array,
        readonly: Boolean,
        isAdmin: Boolean,
        emailEnabled: Boolean,
        documentId: String
    },
    methods: {
        deleteDocument: function (id) {
            if (id) {
                axios.delete('/ajax/documents/' + id)
                    .then(response => {
                        // nothing to do; server side event will cause refresh
                    })
                    .catch(error => {
                        let title = error.response.data.title;
                        let message = error.response.data.message;
                        let level = error.response.data.level;
                        toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                    });
            } 
        }
    }
}
</script>

<style scoped>

</style>